import EA from '../helpers/init';

export default EA.Methods.desktopDropdownHandler = ($this) => {
    const linksWithDropdown = $this.querySelectorAll('.header-main-nav-link.has-submenu');

    linksWithDropdown.forEach(link => {
        const dropdownTrigger = link.querySelector('.submenu-trigger');

        // Link mouse enter handler
        link.addEventListener('mouseenter', () => {
            dropdownTrigger.setAttribute('aria-expanded', true);

            link.classList.add('active');
            link.querySelector('.desktop-dropdown').removeAttribute('inert');
        });

        // Link mouse leave handler
        link.addEventListener('mouseleave', () => {
            dropdownTrigger.setAttribute('aria-expanded', false);

            link.classList.remove('active');
            link.querySelector('.desktop-dropdown').setAttribute('inert', true);
        });

        // Link escape key handler
        link.addEventListener('keydown', (event) => {
            if(event.key === 'Escape') {    
                dropdownTrigger.setAttribute('aria-expanded', false);

                link.classList.remove('active');
                link.querySelector('.desktop-dropdown').setAttribute('inert', true);

                dropdownTrigger.focus();
            }
        });

        // Link focusout handler
        link.addEventListener('focusout', (event) => {
            const nextFocusedElement = event.relatedTarget;

            if(!nextFocusedElement || !link.contains(nextFocusedElement)) {
                dropdownTrigger.setAttribute('aria-expanded', false);

                link.classList.remove('active');
                link.querySelector('.desktop-dropdown').setAttribute('inert', true);
            }
        });

        // Dropdown trigger click handler
        dropdownTrigger.addEventListener('click', () => {
            const isCurrentlyActive = link.classList.contains('active');
            const lastActiveDropdown = $this.querySelector('.header-main-nav-link.has-submenu.active');

            if(lastActiveDropdown) {
                lastActiveDropdown.querySelector('.submenu-trigger').setAttribute('aria-expanded', false);
                lastActiveDropdown.classList.remove('active');
                lastActiveDropdown.querySelector('.desktop-dropdown').setAttribute('inert', true);
            }

            if(isCurrentlyActive) return;

            dropdownTrigger.setAttribute('aria-expanded', true);

            link.classList.add('active');
            link.querySelector('.desktop-dropdown').removeAttribute('inert');
        });
    });
};